module.exports = __webpack_public_path__ + "img/Kibe75.adb4341d.jpg";